<div class="content-container bg-white">
    <h1>{{ 'cards.title' | translate }}</h1>

    <h4>{{ 'cards.import' | translate }}</h4>

    <!-- Import -->
    <div class="row" id="rfidCardsImport">
        <div class="btn-bar justify-content-between">
            <input type="file" accept="xls" (change)="rfidCardsFileSelected($event.target['files'])">

            <button class="btn btn-primary" type="submit"
                    [disabled]="!rfidCardsFileToUpload" (click)="importRfidCardsFile()"
                    translate="cards.actions.import">
            </button>
        </div>
    </div>

    <hr class="mt-4 mb-4">


    <div class="btn-bar">
        <button class="btn btn-primary"
                (click)="create()"
                translate="cards.actions.add"></button>
    </div>

    <!-- Filters -->
    <div class="row">

        <div class="default-filter-form-field">
            <label class="form-label" for="cardNumber">{{ 'cards.table.cardNumber' | translate }}</label>
            <input class="form-control" id="cardNumber" (keyup)="searchCriteriaChanged()"
                   placeholder="{{'cards.table.cardNumber' | translate}}"
                   [formControl]="cardNumber"/>
        </div>
        <div class="default-filter-form-field">
            <label class="form-label" for="cardUid">{{ 'cards.table.uid' | translate }}</label>
            <input class="form-control" id="cardUid" (keyup)="searchCriteriaChanged()"
                   placeholder="{{'cards.table.uid' | translate}}"
                   [formControl]="cardUid"/>
        </div>
        <div class="default-filter-form-field">
            <label class="form-label" for="rfidCardsStatus">{{ 'cards.table.status' | translate }}</label>
            <ng-multiselect-dropdown id="rfidCardsStatus" style="width: 100%;"
                                     placeholder="{{ 'common.multiselect.placeholder' | translate }}"
                                     [formControl]="cardState"
                                     [settings]="rfidCardStatusSettings"
                                     [data]="rfidCardStatusSource"
                                     (ngModelChange)="searchCriteriaChanged()">
            </ng-multiselect-dropdown>
        </div>

        <div class="default-filter-form-field">
            <label class="form-label" for="">{{ 'cards.table.user' | translate }}</label>
            <app-search-customer (selectedCustomerEvent)="customerSelected($event)"></app-search-customer>
        </div>

        <div class="btn-bar">
            <input class="btn btn-outline-secondary" type="button"
                   [value]="'common.clearFilter' | translate"
                   [disabled]="!isFiltering()"
                   (click)="clearFilter()">
        </div>
    </div>

    <ngx-datatable
        class="material"
        [columnMode]="'force'"
        [rows]="rfidCards.results"
        [headerHeight]="50"
        [footerHeight]="50"
        [reorderable]="false"
        rowHeight="50"
        [externalPaging]="true"
        [externalSorting]="true"
        [count]="rfidCards.rowCount"
        [messages]="{
                    totalMessage: 'common.datatable.total' | translate
                    }"
        [offset]="crtPage"
        [limit]="rfidCards.pageSize"
        (page)="setPage($event)"
        (sort)="onSort($event)"
        [sorts]="[{prop: 'cardNumber', dir: 'asc'}]"
        [scrollbarH]="true">


        <ngx-datatable-column [width]="225" sortable="true" prop="cardNumber"
                              name="{{'cards.table.cardNumber' | translate}}">
        </ngx-datatable-column>

        <ngx-datatable-column [width]="225" prop="uid" name="{{'cards.table.uid' | translate}}" sortable="true">
        </ngx-datatable-column>

        <ngx-datatable-column [width]="150" prop="cardState" name="{{'cards.table.status' | translate}}"
                              sortable="true">
            <ng-template ngx-datatable-cell-template let-rfidCard="row">
                {{"cards.status." + rfidCard.cardState.toLowerCase() | translate}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="150" name="{{'cards.table.user' | translate}}" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-rfidCard="row">
                {{rfidCard.customerId ? (rfidCard.customerClientNumber + ' ' + rfidCard.customerFirstName + ' ' + rfidCard.customerLastName) : ''}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="100" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-rfidCard="row">
                <div class="d-flex justify-content-end">
                    <button class="btn btn-link btn-sm" [disabled]="!rfidCard.customerId"
                            title="{{'common.tooltip.viewCustomer' | translate}}"
                            [appHasAnyPermission]="[PermissionKeys.gestionClients]"
                            [routerLink]="['/users/customers/', rfidCard.customerId]">
                        <fa-icon [icon]="faUserPen"></fa-icon>
                    </button>
                    <button class="btn btn-link btn-sm" title="{{'common.tooltip.edit' | translate}}"
                            (click)="update(rfidCard)"
                            [disabled]="isVirtualCard(rfidCard)">
                        <fa-icon [icon]="faPen"></fa-icon>
                    </button>
                    <button class="btn btn-link btn-sm" title="{{'common.tooltip.delete' | translate}}"
                            (click)="delete(rfidCard)" [disabled]="rfidCard.customerId !== null">
                        <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>
